import type { InjectionKey } from 'vue';

/**
 * Provided as true where a value sits right-aligned in a label and value row,
 * such as a record's Details sections. There the side-peek button floats just
 * left of the value instead of taking room after it. A button that takes room
 * pushed every ID 22 pixels in from the edge, while the values around it sat
 * flush, even though the button only shows on hover.
 */
export const SIDE_PEEK_BUTTON_FLOATS: InjectionKey<boolean> = Symbol('side-peek-button-floats');
